function setupWarrantyPage() {
  if (!jQuery('section > div').hasClass('warranty-registration')) return

  jQuery('.resources #search').click(function (e) {
    e.preventDefault()
  })

  jQuery('.pool-color-not-listed')
    .unbind()
    .click(function (e) {
      if (jQuery('.custrecord_tir_other_pool_color').hasClass('hidden')) {
        jQuery('.custrecord_tir_other_pool_color').removeClass('hidden')
        jQuery('#custrecord_eb_pool_warr_item').attr('disabled', true)
        jQuery('#custrecord_tir_other_pool_color').attr('required', true)
        jQuery('#custrecord_tir_other_pool_color').attr('disabled', false)
      } else {
        jQuery('.custrecord_tir_other_pool_color').addClass('hidden')
        jQuery('#custrecord_eb_pool_warr_item').attr('disabled', false)
        jQuery('#custrecord_tir_other_pool_color').attr('required', false)
        jQuery('#custrecord_tir_other_pool_color').attr('disabled', true)
      }
    })

  jQuery('.builder-not-listed')
    .unbind()
    .click(function (e) {
      if (jQuery('.builder-not-listed-details').hasClass('hidden')) {
        jQuery('.builder-not-listed-details').removeClass('hidden')
        jQuery('#custrecord_eb_poolbuilder').attr('disabled', true)
        //jQuery('#custrecord_tir_other_builder').attr('required', true)
        //jQuery('#custrecord_tir_other_builder_phone').attr('required', true)
        //jQuery('#custrecord_tir_other_builder_address').attr('required', true)
        //jQuery('#custrecord_tir_other_builder_city').attr('required', true)
        //jQuery('#custrecord_tir_other_builder_state').attr('required', true)
        //jQuery('#custrecord_tir_other_builder_zip').attr('required', true)
        jQuery('#custrecord_tir_other_builder').attr('disabled', false)
        jQuery('#custrecord_tir_other_builder_phone').attr('disabled', false)
        jQuery('#custrecord_tir_other_builder_address').attr('disabled', false)
        jQuery('#custrecord_tir_other_builder_city').attr('disabled', false)
        jQuery('#custrecord_tir_other_builder_state').attr('disabled', false)
        jQuery('#custrecord_tir_other_builder_zip').attr('disabled', false)
      } else {
        jQuery('.builder-not-listed-details').addClass('hidden')
        jQuery('#custrecord_eb_poolbuilder').attr('disabled', false)

        //jQuery('#custrecord_tir_other_builder').removeAttr('required')
        //jQuery('#custrecord_tir_other_builder_phone').removeAttr('required')
        //jQuery('#custrecord_tir_other_builder_address').removeAttr('required')
        //jQuery('#custrecord_tir_other_builder_city').removeAttr('required')
        //jQuery('#custrecord_tir_other_builder_state').removeAttr('required')
        //jQuery('#custrecord_tir_other_builder_zip').removeAttr('required')
        jQuery('#custrecord_tir_other_builder').removeAttr('disabled', true)
        jQuery('#custrecord_tir_other_builder_phone').removeAttr(
          'disabled',
          true
        )
        jQuery('#custrecord_tir_other_builder_address').removeAttr(
          'disabled',
          true
        )
        jQuery('#custrecord_tir_other_builder_city').removeAttr(
          'disabled',
          true
        )
        jQuery('#custrecord_tir_other_builder_state').removeAttr(
          'disabled',
          true
        )
        jQuery('#custrecord_tir_other_builder_zip').removeAttr('disabled', true)
      }
    })

  jQuery('.commercial_or_residential')
    .unbind()
    .change(function (e) {
      if (jQuery(this).val() === 'commercial') {
        jQuery('.custrecord_tir_wetedge_project_name').removeClass('hidden')
        jQuery('#custrecord_tir_wetedge_project_name').attr('required', true)
        jQuery('#custrecord_tir_wetedge_project_name').attr('disabled', false)
      } else {
        jQuery('.custrecord_tir_wetedge_project_name').addClass('hidden')
        jQuery('#custrecord_tir_wetedge_project_name').val('')
        jQuery('#custrecord_tir_wetedge_project_name').removeAttr('required')
        jQuery('#custrecord_tir_wetedge_project_name').attr('disabled', true)
      }
    })

  jQuery('.spa-color-not-listed')
    .unbind()
    .click(function (e) {
      if (jQuery('.custrecord_tir_other_spa_color').hasClass('hidden')) {
        jQuery('.custrecord_tir_other_spa_color').removeClass('hidden')
        jQuery('#custrecord_eb_spa_warr_item').attr('disabled', true)
        jQuery('#custrecord_tir_other_spa_color').attr('required', true)
      } else {
        jQuery('.custrecord_tir_other_spa_color').addClass('hidden')
        jQuery('#custrecord_eb_spa_warr_item').attr('disabled', false)
        jQuery('#custrecord_tir_other_spa_color').removeAttr('required')
      }
    })

  const finishedError = document.getElementById('finish-error')
  const spaFinish = document.getElementById('custrecord_eb_spa_warr_item')
  const poolFinish = document.getElementById('custrecord_eb_pool_warr_item')
  const spaFinishCustom = document.getElementById(
    'custrecord_tir_other_pool_color'
  )
  const poolFinishCustom = document.getElementById(
    'custrecord_tir_other_spa_color'
  )

  document
    .getElementById('warranty-registration-form')
    .addEventListener('submit', (event) => {
      finishedError.className = 'hidden'

      if (
        poolFinish.value.length <= 0 &&
        spaFinish.value.length <= 0 &&
        poolFinishCustom.value.length <= 0 &&
        spaFinishCustom.value.length <= 0
      ) {
        finishedError.className = 'alert margin-bottom-sm alert-danger'

        event.preventDefault()
      }
    })
}

function turnstileWarrantyRegistrationCallBack($token) {
  jQuery('#submit_registration').attr('disabled', false)
}
